var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(true)?_c('SiteHeader',{on:{"parentMethod":_vm.headerVal}}):_vm._e(),_c('v-main',[(_vm.select == null || _vm.select == 0)?_c('SiteHome'):_vm._e(),(_vm.select == 1)?_c('CompanyInfo'):_vm._e(),(_vm.select == 2)?_c('InquiryForm'):_vm._e()],1),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }